module.exports = __webpack_public_path__ + "media/SetB_L2_A.d80a016f.mp3";